import { render, staticRenderFns } from "./CustomOptionSelectorObject.vue?vue&type=template&id=df43a5ce&scoped=true"
import script from "./CustomOptionSelectorObject.vue?vue&type=script&lang=js"
export * from "./CustomOptionSelectorObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df43a5ce",
  null
  
)

export default component.exports